import { Alert, Box, Button } from "@mui/material";

export default function PendingPaymentAlert({ psid, onViewVoucher }) {
  return (
    <Box
      sx={{
        maxWidth: "1200px",
        mx: "auto",
        mb: 3,
        width: "100%",
      }}
    >
      <Alert
        severity='info'
        action={
          <Button
            color='inherit'
            size='small'
            onClick={onViewVoucher}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
            }}
          >
            View Voucher
          </Button>
        }
      >
        Payment pending for PSID: <strong>{psid}</strong>.
      </Alert>
    </Box>
  );
}
